
import { Vue, Component, Prop } from "vue-property-decorator";
import AdmButton from "@afe/admirals-dev/src/components/AdmButton/AdmButton.vue";

@Component({
  components: {
    AdmButton
  }
})
export default class extends Vue {
  @Prop(Object) readonly videos!: { channelUrl: string; items: object[] };
  @Prop(String) readonly title!: string;
  @Prop(String) readonly related!: string;
  @Prop(String) readonly viewMore!: string;

  formatDate(date: string) {
    return date.slice(0, 10);
  }

  formatDuration(duration: string) {
    let hours, minutes, seconds;

    if (duration.includes("H")) {
      hours = duration.slice(2, duration.indexOf("H"));
    } else {
      hours = false;
    }

    if (duration.includes("S")) {
      // checks if number is one-digit and inserts 0 in front of it
      if (isNaN(parseInt(duration.charAt(duration.indexOf("S") - 2)))) {
        seconds = "0" + duration.charAt(duration.indexOf("S") - 1);
      } else {
        seconds = duration.slice(-3, -1);
      }
    } else {
      seconds = "00";
    }

    // determines how minutes are displayed, based on existence of hours and minutes
    if (hours) {
      if (duration.includes("M")) {
        if (duration.indexOf("M") - duration.indexOf("H") === 3) {
          minutes = duration.slice(
            duration.indexOf("H") + 1,
            duration.indexOf("M")
          );
        } else {
          minutes = "0" + duration.charAt(duration.indexOf("M") - 1);
        }
      } else {
        minutes = "00";
      }
    } else {
      if (duration.includes("M")) {
        minutes = duration.slice(2, duration.indexOf("M"));
      } else {
        minutes = "0";
      }
    }

    // distinction because livestreams (P0D) are not considered
    return duration === "P0D"
      ? "Live"
      : `${hours ? hours + ":" : ""}${minutes}:${seconds}`;
  }

  setAltImg(event: any) {
    // Check if actual image is an error placeholder
    if (event.target.naturalWidth < 150) {
      event.target.src = event.target.currentSrc.replace(
        "maxresdefault",
        "mqdefault"
      );
    }
  }

  get mainVideo() {
    return this.videos.items[0] || null;
  }

  get additionalVideos() {
    return this.videos.items.slice(1, 4);
  }

  get showMoreUrl() {
    return this.videos.channelUrl;
  }
}
